import React, { useEffect } from 'react';

// Import chunk error handler
import './chunkErrorHandler';

import App from './components/App';
import * as serviceWorker from './serviceWorker'

import { BrowserRouter } from 'react-router-dom'
import { Grommet } from 'grommet'
import { Helmet } from "react-helmet"

import envConfig from './utils/envConfig'
import { ChosenTheme } from './components/common/theme'

import { createRoot } from 'react-dom/client'
import { CookiesProvider, useCookies } from 'react-cookie';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

// Set up a unique request ID for tracing
function generateControlRequestId() {
    const env = process.env.REACT_APP_ENVIRONMENT || 'unknown';
    // fallback when crypto.randomUUID not available
    const id = (typeof crypto !== 'undefined' && crypto.randomUUID)
        ? crypto.randomUUID()
        : uuidv4();
    return `ControlUI-${env}-${id}`
}

axios.interceptors.request.use((config) => {
    config.headers = config.headers || {};
    config.headers['X-TT-Request-ID'] = generateControlRequestId();
    return config;
}, (error) => Promise.reject(error));

const ClearCookies = () => {
    const [cookies, , removeCookie] = useCookies();

    useEffect(() => {
        // Clear all cookies on startup
        Object.keys(cookies).forEach(cookie => {
            removeCookie(cookie);
        });
    }, [removeCookie, cookies]); // Runs when cookies change

    return null; // This component does not render anything
};

const container = document.getElementById('root')
const root = createRoot(container)
const appTitle = envConfig[process.env.REACT_APP_ENVIRONMENT]['header']

const app = (
    <BrowserRouter>
        <Grommet theme={ChosenTheme()} full>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{appTitle}</title>
            </Helmet>
            <CookiesProvider>
                <ClearCookies />
                <App />
            </CookiesProvider>
        </Grommet>
    </BrowserRouter>
)

root.render(app)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
